module.exports = __webpack_public_path__ + "img/close.ea68aae6.svg";